import React from "react";
import { Switch } from "@sscs/ui";
const TriagedSwitch = ({ hideTriaged, onToggle, }) => {
    return (React.createElement(Switch, { title: "Filter secrets", label: "Hide triaged", checked: hideTriaged, onChange: (event) => onToggle(event.target.checked) }));
};
export default TriagedSwitch;
//# sourceMappingURL=TriagedSwitch.js.map